const benProfileReducer = (
  initialState = {
    beneficiaryInfo: {},
    parents: {},
    caregivers: {},
    currentInsurance: {},
    currentUbudeheCategory: {},
    currentCaregivers: {},
    currentScore: {},
    currentResidence: {},
    currentSchool: {},
    lastSatStudy: {},
    lastMeeting: {},
    lastVisit: {},
    lastAssocciation: {},
    lastFund: {},
    lastRecordedMarks: {},
    lastHealthTest: {},
    allHealthTests: [],
    allMeetings: [],
    allSatStudies: [],
    allVisits: [],
    allAssocciations: [],
    allFunds: [],
    allGroups: [],
    allLetters: [],
    allProperties: [],
  },
  action
) => {
  switch (action.type) {
    case "GET_BENEFICIARY_INFO":
      return {
        ...initialState,
        beneficiaryInfo: action.beneficiary.data,
      };
    case "GET_BENEFICIARY_PARENTS":
      return {
        ...initialState,
        parents: action.parents.data,
      };
    case "GET_BENEFICIARY_CURRENT_CAREGIVERS":
      return {
        ...initialState,
        currentCaregivers: action.currentCaregivers.data,
      };
    case "GET_BENEFICIARY_CURRENT_INSURANCE":
      return {
        ...initialState,
        currentInsurance: action.currentInsurance.data,
      };
    case "GET_BENEFICIARY_CURRENT_UBUDEHE_CATEGORY":
      return {
        ...initialState,
        currentUbudeheCategory: action.currentCategory.data,
      };
    case "GET_BENEFICIARY_CURRENT_RESIDENCE":
      return {
        ...initialState,
        currentResidence: action.currentResidence.data,
      };
    case "GET_BENEFICIARY_CURRENT_SCHOOL":
      return {
        ...initialState,
        currentSchool: action.currentSchool.data,
      };
    case "GET_BENEFICIARY_LAST_SAT_STUDY":
      return {
        ...initialState,
        lastSatStudy: action.attendeeInfo.data,
      };
    case "GET_BENEFICIARY_LAST_MEETING":
      return {
        ...initialState,
        lastMeeting: action.attendeeInfo.data,
      };
    case "GET_BENEFICIARY_LAST_VISIT":
      return {
        ...initialState,
        lastVisit: action.attendeeInfo.data,
      };
    case "GET_BENEFICIARY_LAST_ASSOCCIATION":
      return {
        ...initialState,
        lastAssocciation: action.memberInfo.data,
      };
    case "GET_BENEFICIARY_LAST_FUND":
      return {
        ...initialState,
        lastFund: action.fundInfo.data,
      };
    case "GET_BENEFICIARY_LAST_HEALTH_TEST":
      return {
        ...initialState,
        lastHealthTest: action.attendeeInfo.data,
      };
    case "GET_BENEFICIARY_ALL_ATTENDED_HEALTH_TEST":
      return {
        ...initialState,
        allHealthTests: action.healthTests.data,
      };
    case "GET_BENEFICIARY_ALL_ATTENDED_MEETING":
      return {
        ...initialState,
        allMeetings: action.meetings.data,
      };
    case "GET_BENEFICIARY_ALL_ATTENDED_SAT_STUDIES":
      return {
        ...initialState,
        allSatStudies: action.satStudies.data,
      };

    case "GET_BENEFICIARY_ALL_ATTENDED_VISIT":
      return {
        ...initialState,
        allVisits: action.visits.data,
      };
    case "GET_BENEFICIARY_ALL_ASSOCCIATIONS":
      return {
        ...initialState,
        allAssocciations: action.assocciations.data,
      };
    case "GET_BENEFICIARY_ALL_RECEIVED_FUNDS":
      return {
        ...initialState,
        allFunds: action.funds.data,
      };
    case "GET_BENEFICIARY_ALL_GROUPS":
      return {
        ...initialState,
        allGroups: action.groups.data,
      };
    case "GET_BENEFICIARY_ALL_LETTERS":
      return {
        ...initialState,
        allLetters: action.letters.data,
      };
    case "GET_BENEFICIARY_LAST_MARKS":
      return {
        ...initialState,
        currentScore: action.currentScore.data,
      };
    case "GET_BENEFICIARY_ALL_PROPERTIES":
      return {
        ...initialState,
        allProperties: action.properties.data,
      };
    default:
      return initialState;
  }
};

export default benProfileReducer;
